document.addEventListener('DOMContentLoaded', () => {
  m_products = [
    {
      sku: 'LH-300',
      materials: ['pappe', 'folien'],
      size: {
        min: 108,
        max: 152
      }
    },
    {
      sku: 'LH-500',
      materials: ['pappe', 'folien'],
      size: {
        min: 196,
        max: 218
      }
    },
    {
      sku: 'MF-100',
      materials: ['pappe', 'folien'],
      size: {
        min: 34,
        max: 44
      }
    },
    {
      sku: 'MF-150',
      materials: ['pappe', 'folien'],
      size: {
        min: 44,
        max: 66
      }
    },
    {
      sku: 'MF-250',
      materials: ['pappe', 'folien'],
      size: {
        min: 66,
        max: 108
      }
    },
    {
      sku: 'MF-40-PET',
      materials: ['pet-flaschen'],
    },
    {
      sku: 'MF-450',
      materials: ['pappe', 'folien'],
      size: {
        min: 152,
        max: 196
      }
    },
    {
      sku: 'MF-450-HD',
      materials: ['kunststoffhohlkoerper', 'pappe', 'folien'],
      size: {
        min: 152,
        max: 196
      }
    },
    {
      sku: 'MF-550',
      materials: ['pappe', 'folien'],
      size: {
        min: 196,
        max: 240
      }
    },
    {
      sku: 'MF-550-HD',
      materials: ['reifen', 'kunststoffhohlkoerper', 'pappe', 'folien'],
      size: {
        min: 218,
        max: 1000
      }
    },
    {
      sku: 'MF-60',
      materials: ['pappe', 'folien'],
      size: {
        min: 0,
        max: 20
      }
    },
    {
      sku: 'MF-650',
      materials: ['pappe', 'folien'],
      size: {
        min: 152,
        max: 196
      }
    },
    {
      sku: 'MF-75',
      materials: ['pappe', 'folien'],
      size: {
        min: 0,
        max: 34
      }
    },
    {
      sku: 'MF-75-MC',
      materials: ['pappe', 'folien'],
      size: {
        min: 0,
        max: 64
      }
    },
    {
      sku: 'MF-200-MC',
      materials: ['pappe', 'folien'],
      size: {
        min: 64,
        max: 86
      }
    },
    {
      sku: 'MF-BAG-PRESS',
      materials: ['restmuell'],
    },
    {
      sku: 'MF-BARREL-PRESS',
      materials: ['faesser', 'restmuell'],
    },
    {
      sku: 'MF-BIN-PRESS',
      materials: ['restmuell'],
    },
    {
      sku: 'MF-GLASS-CRUSHER',
      materials: ['glas'],
    },
    {
      sku: 'MF-60-HD',
      materials: ['dosen'],
    },
  ];

  m_configurator = document.getElementById('lxit-configurator');
  m_material = m_configurator.querySelector('select[name="material"]');
  m_bundlesPerDay = m_configurator.querySelector('select[name="bundles-per-day"]');
  m_containerType = m_configurator.querySelector('select[name="container-type"]');
  m_quantity = m_configurator.querySelector('input[name="quantity"]');
  m_collectionsPerMonth = m_configurator.querySelector('input[name="collections-per-month"]');
  m_submitBtn = m_configurator.querySelector('input[type=submit]');

  m_material.addEventListener('change', function() {
 
    if (
      this.value === 'pet-flaschen' ||
      this.value === 'restmuell' ||
      this.value === 'faesser' ||
      this.value === 'glas' ||
      this.value === 'dosen' ||
      this.value === 'reifen' ||
      this.value === 'kunststoffhohlkoerper'
    ) {
      m_bundlesPerDay.required = false;
      m_containerType.required = false;
      m_quantity.required = false;
      m_collectionsPerMonth.required = false;
      
      m_bundlesPerDay.parentElement.parentElement.style.display = 'none';
      m_containerType.parentElement.parentElement.style.display = 'none';
      m_quantity.parentElement.parentElement.style.display = 'none';
      m_collectionsPerMonth.parentElement.parentElement.style.display = 'none';

      m_sizeMatters = false;
      console.log("size matters = false");
    }
    else{
      m_bundlesPerDay.required = true;
      m_containerType.required = true;
      m_quantity.required = true;
      m_collectionsPerMonth.required = true;
      
      m_bundlesPerDay.parentElement.parentElement.style.display = 'block';
      m_containerType.parentElement.parentElement.style.display = 'block';
      m_quantity.parentElement.parentElement.style.display = 'block';
      m_collectionsPerMonth.parentElement.parentElement.style.display = 'block';

      m_sizeMatters = true;
      console.log("size matters = true");
    }
  });

  m_submitBtn.addEventListener('click', event => handleSubmit(event));
});

let m_products = [];
let m_configurator = null;
let m_bundlesPerDay = null;
let m_material = null;
let m_containerType = null;
let m_quantity = null;
let m_collectionsPerMonth = null;
let m_submitBtn = null;
let m_sizeMatters = true;

function handleSubmit(event) {
  event.preventDefault();

  let isValid = true;
  const formElements = m_configurator.elements;
  for (elm of formElements) {
    elm.classList.remove('invalid');
    if (elm.checkValidity() === false || elm.required && elm.value === "undefined")
    {
      elm.classList.add('invalid');
      isValid = false;
    }
  }

  if (isValid)
  {
    const bundlesPerDay = parseInt(m_bundlesPerDay.value);
    const material = m_material.value;
    const containerType = m_containerType.value;
    const quantity = parseInt(m_quantity.value);
    const collectionsPerMonth = parseInt(m_collectionsPerMonth.value);

    let matchingProducts = [];
    if (m_sizeMatters)
    {
      let size = quantity * collectionsPerMonth / bundlesPerDay;

      if (material === 'pappe' && containerType === 'with-pressing')
        size *= 3;
      else if (material === 'folien' && containerType === 'without-pressing')
        size *= 0.6;
      else if (material === 'folien' && containerType === 'with-pressing')
        size *= 3.4;
        
      matchingProducts = filterProductsByMaterialAndSize(material, size);
    }
    else
    {
      matchingProducts = filterProductsByMaterial(material);
    }
    
    let searchQuery = '/search?q='
    matchingProducts.forEach((product, index) => {
      let searchParam = '';
      if (index === 0)
        searchParam = 'variants.sku:' + product.sku;
      else
        searchParam = '+OR+variants.sku:' + product.sku;
      
      searchQuery += searchParam;
    });
      
    window.location.href = searchQuery;
  } 
  else {
    alert ("Bitte füllen Sie alle Felder ordnungsgemäß aus.");
  }
}

function filterProductsByMaterialAndSize(material, size) {
  return m_products.filter(product => 
    product.materials.includes(material) && 
    product.size.min <= size &&
    product.size.max >= size
  );
}

function filterProductsByMaterial(material) {
  return m_products.filter(product => 
    product.materials.includes(material)
  );
}